import TagManager from 'react-gtm-module';

// GTM Container ID - replace with your actual GTM container ID
const GTM_ID = 'GTM-N639P3G';

// Initialize GTM
export const initGTM = () => {
  const tagManagerArgs = {
    gtmId: GTM_ID,
    dataLayer: {
      // Add any initial data layer variables here
      // Note: Page views are handled automatically by GTM
    },
  };

  TagManager.initialize(tagManagerArgs);
  console.log('GTM initialized with ID:', GTM_ID);
};

// Generic function to push events to GTM
export const pushToGTM = (data) => {
  TagManager.dataLayer({
    dataLayer: {
      ...data,
    },
  });
};

// // Specific event functions
// export const trackPageView = (page, title = null) => {
//   pushToGTM({
//     event: 'page_view',
//     page_path: page,
//     page_title: title || document.title,
//   });
// };

export const trackEvent = (eventName, parameters = {}) => {
  pushToGTM({
    event: eventName,
    ...parameters,
  });
};

// // Application specific events
// export const trackLoanApplication = (step, data = {}) => {
//   pushToGTM({
//     event: 'loan_application',
//     application_step: step,
//     ...data,
//   });
// };

// export const trackFormSubmission = (formName, data = {}) => {
//   pushToGTM({
//     event: 'form_submission',
//     form_name: formName,
//     ...data,
//   });
// };

// export const trackButtonClick = (buttonName, location = null) => {
//   pushToGTM({
//     event: 'button_click',
//     button_name: buttonName,
//     button_location: location,
//   });
// };

// export const trackConversion = (conversionType, value = null, currency = 'EUR') => {
//   pushToGTM({
//     event: 'conversion',
//     conversion_type: conversionType,
//     value: value,
//     currency: currency,
//   });
// }; 